import React from 'react';
import ReactDatePicker from 'react-datepicker';
import type { DatepickerProps, SelectProps } from './Datepicker.typed';
import * as Styled from './Datepicker.styled';
import Icon from '../Icon/Icon';
import { HeaderProps } from './Datepicker.typed';
import Dropdown from '../Dropdown/Dropdown';
import dayjs from 'dayjs';

// TODO: Share code with custom multi select

const getYear = (date: Date): number => {
  return date.getFullYear();
};
const getMonth = (date: Date): number => {
  return date.getMonth();
};
const getRange = (start: number, end: number) => {
  const data = new Array(end - start + 1).fill(0);
  return data.map((_, index) => start + index);
};

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const Select = (props: SelectProps) => {
  const { value, options, onChange } = props;
  return (
    <Styled.SelectWrapper>
      <Styled.SelectedValue aria-hidden={true}>{value}</Styled.SelectedValue>
      <Styled.Select value={value} onChange={onChange}>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Styled.Select>
      <Styled.SelectIcon name="ChevronDownOutline" size="xs" color="#953FFF" />
    </Styled.SelectWrapper>
  );
};
const Header = (props: HeaderProps) => {
  const {
    date,
    changeMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    increaseMonth,
    decreaseMonth,
    changeYear,
    years,
  } = props;

  const onChangeMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
    changeMonth(MONTHS.indexOf(event.target.value));
  };

  const onChangeYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    changeYear(parseInt(event.target.value));
  };

  return (
    <Styled.Header>
      <Styled.MonthButton
        type="button"
        disabled={prevMonthButtonDisabled}
        onClick={decreaseMonth}
      >
        <Icon name="ChevronBackOutline" size="s" color="#953FFF" />
      </Styled.MonthButton>
      <Styled.SelectGroup>
        <Select
          value={MONTHS[getMonth(date)]}
          options={MONTHS}
          onChange={onChangeMonth}
        />
        <Select
          value={getYear(date).toString()}
          options={years}
          onChange={onChangeYear}
        />
      </Styled.SelectGroup>
      <Styled.MonthButton
        type="button"
        disabled={nextMonthButtonDisabled}
        onClick={increaseMonth}
      >
        <Icon name="ChevronForwardOutline" size="s" color="#953FFF" />
      </Styled.MonthButton>
    </Styled.Header>
  );
};

const formatDate = (date: Date) => {
  return dayjs(date).format('DD/MM/YYYY');
};

export const Datepicker = React.forwardRef<HTMLInputElement, DatepickerProps>(
  (props, ref) => {
    const {
      startDate,
      setStartDate,
      yearRange,
      hasError = false,
      disabled = false,
      id,
      placeholder,
      ...rest
    } = props;
    const years = getRange(...yearRange);
    const formattedDate = startDate && formatDate(startDate);

    return (
      <>
        <input
          {...rest}
          ref={ref}
          type="hidden"
          value={formattedDate ?? undefined}
        />
        <Dropdown
          renderAnchor={(props) => (
            <Styled.Button
              hasError={hasError}
              hasValue={!!formattedDate}
              disabled={disabled}
              type="button"
              {...props}
            >
              <span>{formattedDate ?? placeholder}</span>
              <Icon name="ChevronDownOutline" size="s" color="#953FFF" />
            </Styled.Button>
          )}
        >
          {({ close }) => (
            <Styled.Wrapper>
              <ReactDatePicker
                disabled={disabled}
                id={id}
                inline={true}
                onSelect={close}
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={setStartDate}
                calendarStartDay={1}
                renderCustomHeader={(props) => (
                  <Header {...props} years={years} />
                )}
              />
            </Styled.Wrapper>
          )}
        </Dropdown>
      </>
    );
  },
);

export default Datepicker;
